import { render, staticRenderFns } from "./CelebrationPresentation.vue?vue&type=template&id=52c8febc"
import script from "./CelebrationPresentation.vue?vue&type=script&lang=js"
export * from "./CelebrationPresentation.vue?vue&type=script&lang=js"
import style0 from "./CelebrationPresentation.vue?vue&type=style&index=0&id=52c8febc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports